import { render, staticRenderFns } from "./accordion.vue?vue&type=template&id=4ec38f7a&"
import script from "./accordion.vue?vue&type=script&lang=js&"
export * from "./accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports